<template>
  <div class="form-audi" :class="lang">
    <div class="lang">
      <a href="javascript:;" :class="{actived: lang == 'cn'}" @click="lang = 'cn'">中文</a>
      <a href="javascript:;" :class="{actived: lang == 'en'}" @click="lang = 'en'">English</a>
    </div>
    <div class="banner">
      <img :src="lang == 'en' ? 'https://oss.cyzone.cn/2019/0903/22b2b51efbc5712c3b9fc133632ef993.jpeg' : 'https://oss.cyzone.cn/2019/0807/175a70c3bc29387a0fef0e578013cd29.jpeg'" alt />
    </div>

    <div class="form-container com-width">
      <div class="block-title">{{$t('companyTit')}}</div>
      <div class="form-line clearfix">
        <div class="form-label Validform_label">
          {{$t('name')}}
          <span style="color:red;">*</span>
        </div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-input v-model="form.name" />
          </a-col>
        </a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('companyName')}}
          <span style="color:red;">*</span>
        </div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-input v-model="form.company" />
          </a-col>
        </a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">{{$t('companyWebsite')}}</div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-input v-model="form.website" />
          </a-col>
        </a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('city')}}
          <span style="color:red;">*</span>
        </div>
        <a-row class="input-box" :gutter="20">
          <a-col :md="6" :xs="12">
            <a-select class="wid-100" :placeholder="$t('choose')" v-model="form.province_id" @change="getCity">
              <a-select-option v-for="province in provinceArr" :key="province.id" :value="province.id">{{province.name}}</a-select-option>
            </a-select>
          </a-col>
          <a-col :md="6" :xs="12" v-if="cityArr.length">
            <a-select class="wid-100" :placeholder="$t('choose')" v-model="form.city_id">
							<a-select-option v-for="city in cityArr" :key="city.id" :value="city.id">{{city.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>

      <div class="form-line clearfix" v-if="render">
        <div class="form-label">
          {{$t('projectDirection')}}
          <span style="color:red;">*</span>
        </div>
        <div class="input-box">
          <a-radio-group v-model="form.industry_id" @change="chooseIndustri">
            <a-radio v-for="industr in render.industries" :key="industr.id" :value="industr.id">{{industr.name}}</a-radio>
          </a-radio-group>
        </div>
      </div>

      <div class="form-line clearfix xifen" v-if="industriesChild">
        <div class="form-label">
          {{$t('segmentation')}}
          <span style="color:red;">*</span>
        </div>
        <div class="input-box">
          <div class="flex-item label-block">
            <div class="industries-tips">
							<p>{{industriesChild.intro}}</p>
            </div>
						<a-radio-group v-model="form.industri" name="industries">
							<a-radio :style="radioStyle" v-for="industr in industriesChild.child" :key="industr" :value="industr">{{industr}}</a-radio>
						</a-radio-group>
          </div>
        </div>
      </div>

      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('projectBrief')}}
          <span style="color:red;">*</span>
        </div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-textarea
              v-model="form.desc"
              :placeholder="$t('projectBriefPlaceholder')"
              :rows="4"
            />
          </a-col>
        </a-row>
      </div>

      <div class="form-line clearfix" v-if="render">
        <div class="form-label">
          {{$t('financingStatus')}}
          <span style="color:red;">*</span>
        </div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-select class="wid-100" :placeholder="$t('choose')" v-model="form.financing_status">
              <a-select-option v-for="financing in render.financing_status" :key="financing" :value="financing">{{financing}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>

      <div class="form-line clearfix" v-for="(team, index) in teams" :key="index">
        <div class="form-label">
          <div class="team-padd" v-if="index==0">{{$t('team')}} <span style="color:red;">*</span></div>
        </div>
        <div class="input-box">
          <a-row :gutter="20">
            <a-col class="team-padd" :md="4" :xs="12">
              <a-input :placeholder="$t('teamName')" v-model="team.name" />
            </a-col>
            <a-col class="team-padd" :md="6" :xs="12">
              <a-input :placeholder="$t('teamTitle')" v-model="team.position" />
            </a-col>
            <a-col class="team-padd" :md="6" :xs="12">
              <a-input :placeholder="$t('teamEdu')" v-model="team.educational_background" />
            </a-col>
            <a-col class="team-padd" :md="6" :xs="12">
              <a-input :placeholder="$t('teamWork')" v-model="team.work_experience" />
            </a-col>
            <a-col class="team-padd" :md="2" :xs="6">
              <button type="button" class="btn btn-danger wid-100" @click="changeTeams(index)">
                <a-icon type="plus" v-if="index==0" />
                <a-icon type="minus" v-else />
              </button>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="form-line clearfix" id="business_plan">
        <div class="form-label">
          {{$t('bp')}}
          <span style="color:red;">*</span>
        </div>
        <div class="input-box">
          <!-- business_plan -->
          <a-upload name="file" :action="uploadAction" @change="businessChange" :beforeUpload="beforeUpload">
            <a-button class="btn">
              <a-icon type="upload" />{{$t('selectFile')}}
            </a-button>
						<div class="upload-tips">{{$t('bpLimit')}}</div>
          </a-upload>
        </div>
      </div>

      <div class="form-line clearfix">
        <div class="form-label">{{$t('support')}}</div>
        <a-row class="input-box">
          <a-col :span="24">
            <a-textarea v-model="form.ODlCLTlG" :placeholder="$t('supportPlaceholder')" :rows="4" />
          </a-col>
        </a-row>
      </div>

      <div class="block-title">{{$t('contact')}}</div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('contactName')}}
          <span style="color:red;">*</span>
        </div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="24">
            <a-input v-model="form.contact" />
          </a-col>
				</a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('contactPhone')}}
          <span style="color:red;">*</span>
        </div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="24">
            <a-input v-model="form.contact_mobile" />
          </a-col>
				</a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('contactEmail')}}
          <span style="color:red;">*</span>
        </div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="24">
            <a-input v-model="form.contact_email" />
          </a-col>
				</a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">{{$t('position')}}</div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="24">
            <a-input v-model="form.TI3QTNBO" />
          </a-col>
				</a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">{{$t('wechat')}}</div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="24">
            <a-input v-model="form.contact_wechat" />
          </a-col>
				</a-row>
      </div>
      <div class="form-line clearfix">
        <div class="form-label">
          {{$t('captcha')}}
          <span style="color:red;">*</span>
        </div>
				<a-row :gutter="20" class="input-box">
					<a-col :md="8" :xs="16">
            <a-input v-model="form.captcha" />
          </a-col>
					<a-col :md="4" :xs="8">
            <img height="32" :src="captchaUrl" @click="getCaptcha" :alt="$t('captcha')" />
          </a-col>
				</a-row>
      </div>

      <!-- <div class="readme-box">
				<a-checkbox @change="readmeChange">我已阅读并同意</a-checkbox>
        <a href="javascript:;" class="read-me" @click="visible = true">《2019奥迪创新实验室参赛须知》</a>
      </div> -->

      <div class="form-line submit-line clearfix" @click="submitForm">
        <input type="hidden" name="presenter" class="presenter" />
        <button>{{$t('submit')}}</button>
      </div>
    </div>

    <div class="success-layer">
      <div class="layer-content">
        <h3>恭喜您已报名成功</h3>
        <button class="btn">确认</button>
      </div>
    </div>

    <a-modal title="参赛者授权许可声明" :visible="visible" :footer="null" @cancel="visible=false">
      <div style="height: 350px;overflow-y: scroll;">
        <h3>“2019奥迪创新实验室”参赛者授权许可声明</h3>
        <p>在参加由奥迪（中国）企业管理有限公司（以下简称为“公司”）主办的“2019年奥迪创新实验室”大赛（以下简称为“大赛”）前，为了明确参赛作品的知识产权归属，确保每一位参赛者的权益，每一位大赛参赛者均需阅读如下声明。参赛者如果选择参与，参赛者对本声明全部内容给予认可和同意。</p>
        <p>请仔细阅读并确认声明如下：</p>
        <p>本人接受并同意遵守本许可声明的条款。在接受这些条款和规定的前提下，除本人已经及即将提交大赛组委会的授权作品外，本人保留本作品创作过程中的其他权利。</p>
        <p>1. 定义</p>
        <p>“本人”指依据本许可声明的条款提供本作品，行使权利的自然人、法人或者其他组织。</p>
        <p>“本作品”指在本许可条款下已经及即将提交大赛组委会的可受著作权保护的作品，包括但不限于参赛过程中产生的创新想法及方案。亦包含基于本作品，或本作品与其他已存在作品之上而创作的作品，或其他任何对本作品改造、转换、或改写后的形式。</p>
        <p>“提交”是指发送给大赛组委会的任何形式的电子、口头，或书面沟通形式，包括但不限于依据电子邮件、源代码控制系统、问题跟踪系统的传输通讯。</p>
        <p>2. 本人已获知“2019奥迪创新实验室”为公众开放项目。本人在提交本作品后，允许大赛组委会对外公布公开本作品及其成果。其成果公开并不影响本人在作品创作过程中及创作完成时产生并获得的知识产权用于其他目的的处分权；</p>
        <p>3. 本人授权大赛组委会对本作品的著作权及专利权许可。根据本协议条款，大赛组委会在合理使用范围内可永久的、全球性、免版税、非独占地复制、修改、转让、分发、发布、下载、张贴、传输、公开展览、公开表演、公开放映、公开广播或通过信息网络向公众传播本作品的内容；</p>
        <p>4. 本人承诺本作品不存在抄袭、侵权等行为，不存在故意侵犯任何第三方享有的相关知识产权的行为。如果不拥有本作品的所有权、使用权等处分权利的或该作品是剽窃、抄袭他人项目而获得的，所引起的一切后果及法律责任由本人自行承担。若本人参与本赛而导致大赛组委会面临任何第三方的索赔、诉讼或仲裁等要求，或致使大赛组委会因此而遭受任何名誉、声誉或经济上的直接或间接的损失，大赛组委会均有权要求本人采取足够而适当的措施，以保证大赛组委会免受上述索赔、诉讼或仲裁等要求的任何影响。大赛组委会因此而遭受的任何名誉、声誉或经济上的直接或间接的损失，由本人赔偿。</p>
        <p>5. 在参赛过程中，本人允许媒体对其录制与采访，同意大赛组委会在合理范畴内使用本人的肖像进行宣传（包括但不限于赛场现场的布置与展示用途、比赛过程中的合理使用、比赛宣传资料印刷使用），不会因个人隐私权或肖像权的权利而追究公司或第三方媒体的任何责任。</p>
        <p>6. 公司在活动结束后两年内，享有优先合作权。</p>
        <p>7. 如参赛者在大赛结束后的两年内愿对其作品的所有权或知识产权进行转让或许可，参赛者应优先向公司发出书面通知与邀约；同等条件下，公司对其转让或许可享有优先权，不排除已达成合作意向的合作机构。</p>
        <p>8. 公司有权在收到参赛者上述书面许可六个月内，选择是否行使优先权。</p>
        <p>9. 本人在获取参赛资格后，除非因赛制淘汰及不可抗力原因，未经公司确认不得自行退赛。否则，本人将承担相应的赔偿责任。</p>
        <p>10. 本声明书以及与本声明书有关的任何事项均应由中国法律管辖并从其解释。双方应通过友好协商的方式解决在解释、履行、解除或终止本声明书所产生的或与本声明书有关的任何争议。如双方无法协商解决，任何一方有权将争议提交给北京仲裁委员会进行仲裁。仲裁应在北京举行并适用该委员会在接受仲裁时有效的仲裁规则。仲裁裁决是终局的，对双方均有约束力。在争议解决过程中，有争议的条款不影响本声明书其他部分的效力。</p>
        <p>11. 本人已认真阅读了解并完全同意本声明书，愿意参与此次大赛，并同意本声明书。</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as API from "api";
import locale from "@/locale/audi";
const industriesChild = [
	{
		id: 3714,
		intro: "面向中高端客户的移动出行解决方案，为车主带来更加便利的服务以及提升车主驾驶体验；",
		child: ["加油","充电","停车","维修","配件","二手车","保险","代客泊车"]
	},
	{
		id: 3804,
		intro: "通过车载系统，链接车与生活、家庭的相关服务，为车主提供更多服务及选择",
		child: ["智慧家庭","地图导航","金融","定位服务","团购/优惠","旅行","教育","车间通讯"]
	},
	{
		id: 3805,
		intro: "基于司机/乘客的良好感受，营造车内氛围及娱乐系统及交互体验的产品工具",
		child: ["媒体服务","数据信息","音视频","社交","直播","工具类软件"]
	},
	{
		id: 3806,
		intro: "任何基于奥迪车机系统上的创新应用",
		child: ["任何基于奥迪车机系统上的创新应用"]
	}
];
const industriesChildEn = [
	{
		id: 3714,
		intro: "Mobile travel solutions for mid- and high-level customers, providing services that is more convenient and improving driving experience.",
		child: ["refuel", "charging", "parking", "maintenance", "accessories", "used car", "insurance", "valet parking"]
	},
	{
		id: 3804,
		intro: "Provide car owners with more services and options via the vehicle system.",
		child: ["smart home", "map navigation", "finance, LBA", "coupon", "travel", "education", "car-chat"]
	},
	{
		id: 3805,
		intro: "Make product tools for creating inside-car atmosphere, entertainment systems and interaction experience based on good feelings of drivers/passengers.",
		child: ["media services", "data information", "audio/video", "social communication", "Live", "function tools"]
	},
	{
		id: 3806,
		intro: "Any innovative applications based on Audi in-vehicle system",
		child: ["Any innovative applications based on Audi in-vehicle system"]
	}
];

export default {
  name: "home",
  data() {
    return {
      lang: 'cn',
      render: null,
			provinceArr: [],
			cityArr: [],
			industriesChild: null,
			radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
			},

			uploadAction: API.uploadAction,
			teams: [
				{
					name: '',
					position: '',
					educational_background: '',
					work_experience: ''
				}
			],
			captchaUrl: '',
      readme: true,
      visible: false,
			form: {
        act_id: 71,
				intro: "2019奥迪创新实验室"
			}
    };
  },
  computed: {
    formTeams() {
      let name = [];
      let position = [];
      let educational_background = [];
      let work_experience = [];

      this.teams.forEach(item => {
        name.push(item.name);
        position.push(item.position);
        educational_background.push(item.educational_background);
        work_experience.push(item.work_experience);
      });

      return {
        name: name,
        position: position,
        educational_background: educational_background,
        work_experience: work_experience,
      }
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    formTeams(newVal) {
      this.form.teams = newVal;
    },
    lang(newVal) {
      this.$i18n.locale = newVal;
      this.init();
    }
  },
  methods: {
    init() {
      this.lang = this.$i18n.locale;
			this.getConfig();
			this.getProvince();

      this.getCaptcha();
		},
		getCaptcha() {
			this.captchaUrl = `${API.getcaptcha}?t=${new Date().getTime()}`;
		},
		getConfig() {
			API.getProjectInit({
        act_id: this.form.act_id,
        lang: this.lang
      }).then(res => {
        if (res.code == 0) {
          this.render = res.data;
        }
      });
		},
    getProvince() {
			API.getDistrict({
        lang: this.lang
      }).then(res => {
				this.provinceArr = res.code == 0 ? res.data.list : [];
			});
		},
		getCity(id) {
			API.getDistrict({
        pid: id,
        lang: this.lang
			}).then(res => {
				this.cityArr = res.code == 0 ? res.data.list : [];
			});
		},
		chooseIndustri(event) {
      let children = this.lang == 'en' ? industriesChildEn : industriesChild;
			this.industriesChild = children.filter(item => {
				return item.id == event.target.value;
			})[0];
		},
		readmeChange(event) {
			this.readme = event.target.checked;
		},
		beforeUpload (file) {
      const isPDF = file.type === 'application/pdf';
      if (!isPDF) {
        this.$message.error('仅限上传PDF');
      }
      return isPDF
		},
		businessChange (info) {
      if (info.file.status === 'done' && info.file.response.code == 0) {
        this.form.business_plan = info.file.response.data.savepath;
      }
		},
		changeTeams(_index) {
			if(_index == 0) {
         this.teams.push( JSON.parse(JSON.stringify(this.teams[0])) );
			}else {
				this.teams = this.teams.filter((item, index) => {
					return index != _index
				});
			}
    },
    submitForm() {
      if(!this.readme) {
        this.$message.error('需同意2019奥迪创新实验室参赛须知');
        return false;
      }

      API.projectSave(this.form).then(res => {
        if(res.code != 0) {
          this.$message.error(res.msg);
          this.getCaptcha();
          return false;
        }

        this.$message.success('提交成功');
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      });
    }
  }
};
</script>

<style lang="scss">
@mixin css3($property, $value) {
  @each $prefix in -webkit-, -moz-, -ms-, -o-, "" {
    #{$prefix}#{$property}: $value;
  }
}

@mixin opacity($opacity) {
  opacity: $opacity;
  $opacity-ie: $opacity * 100;
  filter: alpha(opacity=$opacity-ie); //IE8
}

body {
  background: #fff;
  padding-top: 50px;
}

a:hover {
  text-decoration: none;
  @include css3("transition", all 0.3s);
}

.wid-100 {
  width: 100%;
}

.lang {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  line-height: 50px;
  background: #333;
  text-align: center;
  z-index: 99;
  a {
    display: inline-block;
    color: #fff;
    padding: 0 20px;
    &.actived {
      background: #ca0828;
    }
  }
}

.success-layer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 9;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #000;
    @include opacity(0.8);
    z-index: 1;
  }

  .layer-content {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -270px;
    margin-top: -180px;
    width: 540px;
    padding: 40px;
    background: #fff;
    z-index: 2;
    text-align: center;

    h3 {
      margin-bottom: 40px;
      font-size: 30px;
    }

    .btn {
      width: 340px;
      height: 60px;
      margin-top: 30px;
      background: #ca0828;
      color: #fff;
      font-size: 20px;
      outline: none;
      border: none;
    }
  }
}

.diy-select {
  width: 100%;
  border: 1px solid #ddd;

  &:hover {
    height: auto;
  }

  & > li {
    position: relative;
    height: 40px;
    line-height: 40px;

    a {
      display: block;
      padding: 0 10px;
      position: relative;

      &:hover {
        background: #f0f0f0;
      }
    }

    ul {
      position: absolute;
      left: 100%;
      top: 0;
      width: 120px;
      background: #fff;
      display: none;
      border: 1px solid #ddd;
    }

    &:hover {
      ul {
        display: block;
      }
    }
  }
}

.com-width {
  width: 1200px;
  margin: 0 auto;
}

.SumoSelect {
  width: 100%;
}

.banner {
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  img {
    display: block;
    width: 100%;
  }
}

.form-line {
  &.hide {
    display: none;
  }
  .btn {
    border: none;
    border: 2px solid #ca0828;
    color: #ca0828;
    padding: 0 20px;
    border-radius: 3px;
    outline: none;
    line-height: 28px;
    background: none;

    &:hover {
      background: #ca0828;
      color: #fff;
      @include css3("transition", all 0.3s);
    }
  }

  .webuploader-pick-hover .btn {
    background: #ca0828;
    color: #fff;
    @include css3("transition", all 0.3s);
  }
}

.form-container {
  background: #fff;
  margin: 30px auto;

  .block-title {
    background: #f6f6f6;
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    font-size: 16px;
    font-weight: bold;
    margin: 15px 0;
  }

  .empty-block {
    height: 30px;
  }

  .form-line {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 8px 15px;
    &.space-item {
      display: none;
    }

    .file-tips {
      color: #666;
      text-transform: uppercase;

      a {
        display: inline-block;
        padding: 0 10px;
        color: #f60;
        text-transform: lowercase;
      }
    }

    .form-label {
      width: 100px;
      position: relative;
      line-height: 32px;
      margin-right: 20px;
      &.label-strong {
        font-size: 18px;
        font-weight: bold;
      }

      .small {
        font-size: 13px;
        color: #999;
      }

      i {
        position: absolute;
        top: 2px;
      }
    }

    &.submit-line {
      padding: 30px 0;
      text-align: center;

      button {
        width: 407px;
        height: 77px;
        line-height: 77px;
        font-size: 24px;
        margin: 0 auto;
        border: none;
        outline: none;
        color: #fff;
        background: #ce0023;
        cursor: pointer;
      }
    }

    .team-padd {
      padding: 5px 0;
    }

    .input-box {
      flex: 1;
      display: flex;

      .ant-row {
        width: 100%;
      }
      button.button {
        margin-left: 10px;
        width: 120px;
        height: 36px;
        color: #f60;
        border: 1px solid #f60;
        background-color: #fff;
        border-radius: 5px;
        outline: none;
        cursor: pointer;

        &:hover {
          color: #fff;
          background-color: #f60;
        }
      }

			.upload-tips {
          color: #999;
          line-height: 2;
          font-size: 12px;
      }

      .flex-item {
        flex: 1;
        padding: 0 5px;

        .industries-tips {
          padding: 5px 10px;
          line-height: 32px;
          background: #f0f0f0;
					margin: 10px 0;
					p {
						margin: 0;
					}
        }

        &.label-block .radio-label {
          display: block;
        }
      }

      &.wrap {
        flex-wrap: wrap;

        .flex-item.item-checkbox {
          padding-right: 50px;
        }
      }
    }
  }

  .add-event-block {
    .form-line {
      padding: 8px 0;
    }
  }

  .add-team-block {
    padding: 12px 0;

    .form-line {
      padding: 10px 0;
    }
  }
}

.readme-layer {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 9;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #000;
    @include opacity(0.8);
    z-index: 1;
  }

  .close {
    position: absolute;
    right: 30px;
    top: 30px;
    z-index: 2;
    color: #fff;
    font-size: 30px;
    cursor: pointer;
  }

  .inner {
    position: absolute;
    width: 56%;
    min-width: 320px;
    height: 56%;
    padding: 2%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow-y: scroll;
    background: #fff;
    z-index: 2;

    h3 {
      font-size: 24px;
      margin-bottom: 30px;
    }

    p {
      margin-bottom: 20px;
      line-height: 1.5;
    }
  }
}

.readme-box {
	margin-top: 30px;
	.read-me {
		color: #ca0828;
	}
}


.form-audi.en {
  .form-container .form-line .form-label {
    width: 150px;
    text-align: right;
    font-size: 13px;
  }

  .form-container .form-line .input-box {
    width: calc(100% - 180px);
  }
}

@media (max-width: 1280px) {
  .com-width {
    width: 960px;
    max-width: 100%;
  }

  .form-container .form-line {
    .form-label {
      width: 100%!important;
      text-align: left!important;
    }
    .input-box.team {
      .flex-item {
        flex: auto;
        width: 100%;
        padding: 5px 0;
      }
    }
  }
}

@media (max-width: 900px) {
  .form-intro {
    height: 170px;
  }
  .footer-img {
    height: 120px;
  }
}
</style>
